var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.5C1.61929 16.5 0.5 17.6193 0.5 19C0.5 20.3807 1.61929 21.5 3 21.5V16.5ZM44.7678 20.7678C45.7441 19.7915 45.7441 18.2085 44.7678 17.2322L28.8579 1.32233C27.8816 0.34602 26.2986 0.34602 25.3223 1.32233C24.346 2.29864 24.346 3.88155 25.3223 4.85786L39.4645 19L25.3223 33.1421C24.346 34.1184 24.346 35.7014 25.3223 36.6777C26.2986 37.654 27.8816 37.654 28.8579 36.6777L44.7678 20.7678ZM3 21.5H43V16.5H3V21.5Z",
    fill: "#C53EAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallarrow);
export default __webpack_public_path__ + "static/media/smallarrow.fe6edc5c4f067f9ca45536d9699acb4e.svg";
export { ForwardRef as ReactComponent };